import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SocketService } from 'src/app/services/socket.service';

@Component({
  selector: 'app-chat-widget',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './chat-widget.component.html',
  styleUrls: ['./chat-widget.component.scss'],
})
export class ChatWidgetComponent {
  showChat = false;
  startChat = false;
  // messages: string[] = [];
  // newMessage = '';
  // message = '';
  name = '';
  messages: any[] = [];

  userId = '';
  recipientId = '';
  message = '';
  registeredUserSocketStatus:any;
  chatLog: { from: string,from_name: string, message: string }[] = [];
  connectionStatus: any;
  onlineUsers: string[] = [];
  btnSubmit:boolean=false;

  constructor(private socketService: SocketService) {}

  ngOnInit() {
    // this.socketService.onMessage().subscribe((msg) => {
    //   this.messages.push({...msg, isSelf:true});
    // });
    

  this.socketService.onPrivateMessage().subscribe(data => {
    console.log('Received private message in component:', data);
    this.chatLog.push(data); // Display or store the message
  });

  this.socketService.registeredUserSocketStatus$.subscribe(res => {
    this.registeredUserSocketStatus = res;
    console.log("registeredUserSocketStatus", this.registeredUserSocketStatus)
    this.startChat = !!this.registeredUserSocketStatus?.success;
  });

  this.socketService.connectionSocketStatus$
  .subscribe(res => {
    this.connectionStatus = res;
    console.log(res);
  });

  this.socketService.onlineUsers$
  .subscribe(users => {
    this.onlineUsers = users;
    console.log("onlineUsers", this.onlineUsers)
    // console.log("onlineUsers Array", Array.from(this.onlineUsers))
    // this.onlineUsers.forEach((element:any) => {
      
    //   if(element.userId==this.userId){
    //   element.selected=true;
    //   }else{
    //     element.selected=false;
    //   }
    // });

  //   const arr = Array.from(this.onlineUsers, ([key,value])=>(
  //     {userId: key, ...value
  //   }
  // ));

  });


  }

  // send() {
  //   if (this.message.trim()) {
  //     this.socketService.sendMessage(this.message, this.name);
  //     this.message = '';
  //   }
  // }

  register() {
    // this.startChat = !this.startChat;
    this.btnSubmit=true;
    // this.socketService.register(this.userId);
    this.socketService.registerUser(this.userId);
    // this.startChat = this.registeredUserSocketStatus?.success;
    // this.startChat && this.registeredUserSocketStatus?.success
    // if(this.registeredUserSocketStatus?.success){
    //   this.startChat=true;
    // }else{
    //   this.startChat =false;
    // }
    // this.startChat = !!this.registeredUserSocketStatus?.success;
    // if(this.registeredUserSocketStatus?.success){
    //   this.startChat=true;
    // }


  }

  // sendMessage() {
  //   this.socketService.sendPrivateMessage(this.currentUserId, this.targetUserId, this.messageText);
  // }
  sendMessage() {
    console.log("send chat::",this.userId, this.recipientId, this.message)
    this.socketService.sendPrivateMessage(this.userId, this.recipientId, this.message);
    this.chatLog.push({ from: 'Me Not Using.....now',from_name: 'Me', message: this.message });
    this.message = '';
  }

  toggleChat() {
    this.showChat = !this.showChat;
  }
  startChartFields() {
    this.startChat = !this.startChat;
  }
  disconnect() {
    this.socketService.disconnect();
  }
  reconnect() {
    this.recipientId='';
    this.socketService.reconnect(this.userId);
  }
  setRecipientId(recipientId:any){

this.recipientId=recipientId;
console.log("set recipientId:",this.recipientId)
this.onlineUsers.forEach((element:any) => {
      
  if(element.userId==this.recipientId){
  element.selected=true;
  }else{
    element.selected=false;
  }
});
  }
  

  // sendMessage() {
  //   if (this.newMessage.trim()) {
  //     this.messages.push(this.newMessage.trim());
  //     this.newMessage = '';
  //   }
  // }
}
